import {types} from './types';

const initialState = {
    list: {
        data: [],
        countPage: 1
    },
    view: {},
    rezyme: {
        data: [],
        countPage: 1
    },
    last_operation: {
        data: [],
        countPage: 1
    },
    user_replenishment: {
        data: [],
        countPage: 1,
    },
    user_widthdrawals: {
        data: [],
        countPage: 1,
    },
    bonuses_history: {
        data: [],
        countPage: 1
    },
    list_jackpot: {
        data: [],
        countPage: 1,
    },
    jackpot: []
}

export function usersMobileReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_USERS_LIST:
            return { ...state, list: action.payload};
        case types.SET_USER_BY_ID:
            return { ...state, view: action.payload};
        case types.SET_REZYME:
            return { ...state, rezyme: action.payload};
        case types.SET_LAST_OPERATION: 
            return { ...state, last_operation: action.payload};
        case types.SET_REPLENISHMENT_USER:
            return { ...state, user_replenishment: action.payload};
        case types.SET_WITHDRAWALS_USER:
            return { ...state, user_widthdrawals: action.payload};
        case types.SET_BONUSES_HISTORY:
            return { ...state, bonuses_history: action.payload};
        case types.SET_HISTORY_LIST:
            return { ...state, list_jackpot: action.payload};
        case types.SET_JACKPOT: 
            return { ...state, jackpot: action.payload};
        default:
            return state
    }
}